import { FC } from 'react';
import { Link } from 'react-router-dom';

import { Box } from '@mui/material';
import { BUSINESS_TOOL } from 'constants/paths';
import { useGetIndustryPictures } from 'services/businessPlan/hooks/useGetIndustryPictures';
import { INDUSTRY_TYPE } from 'services/businessPlan/types';

import { useBusinessToolPageLogic } from 'pages/BusinessToolPage/hooks/useBusinessToolPageLogic';
import { checkIsOnePageBP } from 'pages/BusinessToolPage/utils';
import { getBusinessPlanCard } from 'pages/Workspace/helpers/getBusinessPlanCard';

import { IBusinessPlanEntity, IBusinessPlanType } from 'interfaces/businessPlan';

import { insertId } from 'helpers/path';

import styles from '../WorkspaceBusinessPlans.module.scss';

interface IProps {
  eachBusinessPlan: IBusinessPlanEntity;
  handleNavigate(type: IBusinessPlanType): void;
}

export const WorkspaceBusinessPlanItem: FC<IProps> = ({ eachBusinessPlan, handleNavigate }) => {
  const { initialValues } = useBusinessToolPageLogic({
    businessPlanId: String(eachBusinessPlan.uuid),
    disableStoreSave: true,
  });

  const companySectorLabel =
    typeof initialValues.GLOBAL.companySector === 'object' &&
    initialValues.GLOBAL.companySector &&
    'value' in initialValues.GLOBAL.companySector
      ? initialValues.GLOBAL.companySector.value
      : initialValues.GLOBAL.companySector;

  const isOnePageBP = checkIsOnePageBP(eachBusinessPlan.type);
  const type = INDUSTRY_TYPE[String(companySectorLabel)];
  const enabled = Boolean(!isOnePageBP && type);

  const { data: industryPictures, isFetching } = useGetIndustryPictures({
    type,
    enabled,
  });

  const coverTitle = initialValues?.GLOBAL.coverTitle;
  const companyName = initialValues?.GLOBAL.companyName;
  const pictureUrl = industryPictures?.[0]?.url ?? '';

  return (
    <Box className={styles.card} key={eachBusinessPlan.uuid} onClick={() => handleNavigate(eachBusinessPlan.type)}>
      <Link to={insertId(BUSINESS_TOOL, eachBusinessPlan.uuid)} className={styles.link} />
      {getBusinessPlanCard({
        props: eachBusinessPlan,
        pictureUrl,
        coverTitle,
        isPictureLoading: isFetching,
        companyName,
      })}
    </Box>
  );
};
